import ButtonWrapper from './ButtonWrapper';
import AddIcon from './AddIcon';
import ButtonLabel from './ButtonLabel';
import { FormattedMessage } from 'react-intl';
import { type HTMLButtonProps } from '@/lib/types';

type AddLevelButtonProps = Omit<HTMLButtonProps, 'children'>;

const AddLevelButton = (props: AddLevelButtonProps) => (
  <ButtonWrapper {...props}>
    <AddIcon />
    <ButtonLabel>
      <FormattedMessage id="portfolio_template_editor.add_level.title" />
    </ButtonLabel>
  </ButtonWrapper>
);

export default AddLevelButton;
